export default __webpack_public_path__ + "static/media/base-ondas.fb2c9e9d.png";